import { DatePicker, Form, Input, Select } from 'antd';
import { FormInstance } from 'antd/es/form/hooks/useForm';
import { useTranslation } from 'translations/hooks';

import { UpdateDefectFormValues } from './types';

interface FormOption {
  label: string;
  value: string;
}

interface UpdateDefectFormProps {
  form: FormInstance<UpdateDefectFormValues>;
  save: (row: UpdateDefectFormValues) => void;
  initialValues: UpdateDefectFormValues;
  typeOptions: FormOption[];
  zoneOptions: FormOption[];
  loading: boolean;
}

export const UpdateDefectForm: React.FC<UpdateDefectFormProps> = ({
  form,
  save,
  initialValues,
  typeOptions,
  zoneOptions,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <Form<UpdateDefectFormValues>
      form={form}
      layout="vertical"
      onFinish={save}
      initialValues={initialValues}
    >
      <Form.Item<UpdateDefectFormValues>
        name="date"
        label={t('qualityControl.segmentHistory.drawer.defectModal.dateLabel')}
        rules={[{ required: true }]}
      >
        <DatePicker
          style={{ width: '100%' }}
          showTime={{ format: 'HH:mm' }}
          format="L HH:mm"
          allowClear={false}
        />
      </Form.Item>
      <Form.Item<UpdateDefectFormValues>
        name="type"
        label={t('qualityControl.segmentHistory.drawer.details.type_defect')}
        rules={[{ required: true }]}
      >
        <Select options={typeOptions} allowClear={false} loading={loading} />
      </Form.Item>
      <Form.Item<UpdateDefectFormValues>
        name="zone"
        label={t('qualityControl.segmentHistory.drawer.details.zone')}
        rules={[{ required: true }]}
      >
        <Select options={zoneOptions} allowClear={false} loading={loading} />
      </Form.Item>
      <Form.Item<UpdateDefectFormValues>
        name="description"
        label={t('qualityControl.segmentHistory.drawer.details.comment')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    </Form>
  );
};
